export const VIDFLEET_SHOW_CHANGES_HISTORY_LIST = "VIDFLEET_SHOW_CHANGES_HISTORY_LIST";
export const VIDFLEET_SHOW_CHANGES_HISTORY_LIST_RESPONSE = "VIDFLEET_SHOW_CHANGES_HISTORY_LIST_RESPONSE";
export const VIDFLEET_SHOW_CHANGES_HISTORY_HIDE = "VIDFLEET_SHOW_CHANGES_HISTORY_HIDE";